import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useNavigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LoginPage from "@/pages/LoginPage";
import AdminDashboard from "@/pages/AdminDashboard";
import RestaurantDashboard from "@/pages/RestaurantDashboard";
import PublicMenu from "@/pages/PublicMenu";
import api from "@/lib/api";

function RootRedirect() {
  const navigate = useNavigate();
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) { navigate("/login"); return; }
    api.auth.me()
      .then((r) => {
        if (r.data.role === "admin") navigate("/admin");
        else navigate("/restaurant");
      })
      .catch(() => {
        localStorage.removeItem("token");
        navigate("/login");
      })
      .finally(() => setChecked(true));
  }, [navigate]);

  if (!checked) return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: '#FDFBF7' }}>
      <div className="animate-pulse font-heading text-2xl" style={{ color: '#C05C46' }}>Cargando...</div>
    </div>
  );
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/restaurant" element={<RestaurantDashboard />} />
          <Route path="/menu/:slug" element={<PublicMenu />} />
          <Route path="/" element={<RootRedirect />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
